<template>
  <div class="apex-chart">
    <ApexChart
      height="100%"
      :options="config"
      :series="series"
    />
  </div>
</template>
<script setup lang="ts">
import { PropType } from 'vue'
import ApexChart from 'vue3-apexcharts'

defineProps({
  config: Object as PropType<Record<string, any>>,
  series: Object as PropType<Record<string, any>>,
})
</script>
<style scoped>
:deep(.apexcharts-tooltip),
:deep(.apexcharts-tooltip *) {
  color: white !important;
  background: #1e1e1e !important;
  border: none !important;
  box-shadow: none !important;
  padding: 4px 4px;
}
.apex-chart {
  width: 60%;
}

:deep(.apexcharts-bar-series path) {
  cursor: pointer !important;
}

@media (max-width: 960px) {
  .apex-chart {
    width: 100%;
  }
}
</style>
